import { useState, useEffect } from "react";
import siteLogo from "../../../logos/siteLogo.png";
import { useDispatch, useSelector } from "react-redux";
import {
  setTruInkAllSites,
  setTruInkSelectedSite,
  setTruInkSelectedSiteOption,
} from "../../../redux/slices/truInk";
import callPiggybackAPI from "../Helpers/piggyback.api.helper";
import AddSiteModal from "./AddSiteModal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

function TruInkSiteSelector() {
  const dispatch = useDispatch();
  const sites = useSelector((state) => state?.truInk?.allSites);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    fetchSites();
  }, [dispatch]);

  const handleCreateSite = async (newSiteData) => {
    const tenantId = "f4ff8ea8-5d8a-4a47-917c-e0ce6da54427";

    const body = {
      tenantId: tenantId,
      name: newSiteData.name,
      location: newSiteData.location,
    };

    const apiResponse = await callPiggybackAPI("site", {}, body, "POST");

    if (apiResponse) {

      await fetchSites();
    } else {
      console.error("Failed to create new site.");
      setError("Failed to create new site.");
    }
  };

  const handleAddSiteClick = () => {
    setIsModalOpen(true);
  };

  const fetchSites = async () => {
    const query = {};
    setLoading(true);
    setError(null);
    const apiResponse = await callPiggybackAPI("site", query, {}, "GET");

    if (apiResponse) {
      dispatch(setTruInkAllSites(apiResponse));
    } else {
      setError("Failed to fetch sites. Please try again.");
    }
    setLoading(false);
  };

  const handleSiteClick = (site) => {
    dispatch(setTruInkSelectedSite(site));
    dispatch(setTruInkSelectedSiteOption("SiteData"));
  };

  if (loading) {
    return <div>Loading sites...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <Box
      sx={{
        color: "black",
        height: "100%",
        width: "100%",
        paddingLeft: {
          xs: "3%",
          sm: "5%",
          md: "9%"
        },
        paddingRight: {
          xs: "3%",
          sm: "5%",
          md: "9%"
        },
        marginTop:{xs:"3%",sm:"2%",md:"unset"},
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Typography
          sx={{
            color: "rgb(90, 28, 47)",
            fontSize: "1rem",
            fontWeight: "bold",
            marginBottom: "0px",
          }}
        >
          Welcome to the world of digital labels!
        </Typography>

        <Typography
          sx={{
            color: "rgb(90, 28, 47)",
            fontSize: "0.7rem",
          }}
        >
          Select your site to continue.
        </Typography>
      </Box>
      <Box
        sx={{
          mt: {
            xs: 1,
            sm: "2.5vh",
            md: "3vh",
            lg: "3vh",
          },
          display: "flex",
          flexDirection: "row",
          gap: {
            xs: 1,
            md: 2,
          },
          alignItems: "flex-start",
          width: "100%",
          flexWrap: "wrap",
          overflowY: "auto",
          scrollbarWidth: "none",
        }}
      >
        {sites.map((site, index) => (
          <Box
            key={index}
            onClick={() => handleSiteClick(site)}
            sx={{
              marginBottom: { md: "1rem" },
              padding: "1rem",
              border: "1px solid #ccc",
              borderRadius: "1.5vw",
              width: {
                xs: "100%",
                sm: "45%",
                md: "16vw",
              },

              height: {
                xs: "16vh",
                sm: "17vh",
                md: "18vh",
                lg: "18vh",
              },

              backgroundImage: `
      linear-gradient(rgba(105, 30, 45, 0.7), rgba(105, 30, 45, 0.7)),
      url(${siteLogo})
    `,

              backgroundSize: "cover",
              backgroundPosition: "center",

              display: "flex",
              flexDirection: "column",
              justifyContent: "start",
              alignItems: "center",
              color: "white",
              cursor: "pointer",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: "1.1rem",
                  md: "0.9rem",
                },
                textAlign: "center",
              }}
            >
              {site.name}
            </Typography>

            <Typography
              sx={{
                fontSize: {
                  xs: "0.8rem",
                  md: "0.6rem",
                },
                textAlign: "center",
              }}
            >
              {site.storeId}
            </Typography>

            <Typography
              sx={{
                fontSize: {
                  xs: "0.8rem",
                  md: "0.6rem",
                },
                textAlign: "center",
              }}
            >
              {site.address}
            </Typography>
          </Box>
        ))}

      </Box>
      {isModalOpen && (
        <AddSiteModal
          onClose={() => setIsModalOpen(false)}
          onCreate={handleCreateSite}
        />
      )}
    </Box>
  );
}

export default TruInkSiteSelector;
